<div *ngIf="itinerary" fxLayout="row" fxLayout.lt-md="column">
  <mat-card fxFlex>
    <app-itinerary-settings-assignment
      [itinerary]="itinerary"
    ></app-itinerary-settings-assignment>
  </mat-card>
  <span>&nbsp;&nbsp;&nbsp;</span>
  <mat-card>
    <app-itinerary-settings-general
      [itinerary]="itinerary"
    ></app-itinerary-settings-general>
  </mat-card>
</div>
